import { TGetInvoicesListResponseItem, TGpsrProductType } from 'redux/reducers/gpsr/types';
import { DATES_ID, DATES } from 'services/constants/dates-constants';
import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';

type TGetInvoicesListResponseItemWithId = TGetInvoicesListResponseItem & { id: number };

export const gpsrInvoiceListTableStructure: TTableStructure<
	keyof TGetInvoicesListResponseItemWithId
>[] = [
	{
		name: 'Invoice ID',
		selector: 'invoiceId' as keyof TGetInvoicesListResponseItemWithId,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},
	{
		name: 'EM ID',
		selector: 'emId' as keyof TGetInvoicesListResponseItemWithId,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.RIGHT,
		colSpan: 1,
	},

	{
		name: 'Invoice Number',
		selector: 'invoiceNumber' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		searchable: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'EM Name',
		selector: 'emName' as keyof TGetInvoicesListResponseItemWithId,
		show: false,
		sortable: false,
		filterable: false,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		colSpan: 4,
	},
	{
		name: 'Date of Invoice',
		selector: 'dateTime' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: true,
		filterable: true,
		filter: [
			[DATES_ID.TODAY, DATES.TODAY],
			[DATES_ID.YESTERDAY, DATES.YESTERDAY],
			[DATES_ID.LAST_7_DAYS, DATES.LAST_7_DAYS],
			[DATES_ID.LAST_30_DAYS, DATES.LAST_30_DAYS],
			[DATES_ID.THIS_MONTH, DATES.THIS_MONTH],
			[DATES_ID.LAST_MONTH, DATES.LAST_MONTH],
			[DATES_ID.THIS_QUARTER, DATES.THIS_QUARTER],
			[DATES_ID.LAST_QUARTER, DATES.LAST_QUARTER],
			[DATES_ID.THIS_YEAR, DATES.THIS_YEAR],
			[DATES_ID.LAST_YEAR, DATES.LAST_YEAR],
		],

		type: ETableStructureType.DATE,
		align: ETableStructureAlign.CENTER,
		colSpan: 1,
	},
	{
		name: 'Amount',
		selector: 'amount' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: true,
		filterable: false,
		type: ETableStructureType.AMOUNT,
		align: ETableStructureAlign.RIGHT,

		colSpan: 1,
	},
	{
		name: 'Payment Status',
		selector: 'paymentStatus' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: true,
		filter: [
			['paid', 'paid'],
			['pending', 'pending'],
			['partially_paid', 'partially paid'],
		],
		colors: [
			['paid', 'success.light'],
			['pending', 'warning.light'],
			['partially_paid', 'info.light'],
		],
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
	},
	{
		name: 'Actions',
		noName: true,
		selector: 'actions' as keyof TGetInvoicesListResponseItemWithId,
		show: true,
		sortable: false,
		filterable: false,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.LEFT,
		colSpan: 1,
		buttons: [{ name: 'Download' }],
	},
];
